<template>
  <div class="page-wrapper admin-stats-sheet admin-stats-sheet--cols-4">
    <div class="stats-row">
      <div class="mini-stat" v-for="s in courseStats" :key="s.label">
        <div class="mini-stat-icon" :style="{ background: s.bg, color: s.color }"><component :is="s.icon" /></div>
        <div><p class="mini-stat-val">{{ s.value }}</p><p class="mini-stat-label">{{ s.label }}</p></div>
      </div>
    </div>

    <div class="page-toolbar admin-list-toolbar">
      <div class="page-toolbar-left">
        <div class="filter-tabs">
          <button v-for="tab in courseFilterTabs" :key="tab.v" type="button" class="filter-tab"
            :class="{ active: courseFilterTab === tab.v }" @click="courseFilterTab = tab.v">{{ tab.l }}</button>
        </div>
        <div class="search-box">
          <el-icon><Search /></el-icon>
          <input v-model="searchQuery" type="text" placeholder="搜索课程、教练" />
        </div>
      </div>
      <div class="page-toolbar-right">
        <div class="view-toggle">
          <button type="button" class="view-btn" :class="{ active: viewMode === 'grid' }" @click="setViewMode('grid')"><el-icon><Grid /></el-icon></button>
          <button type="button" class="view-btn" :class="{ active: viewMode === 'list' }" @click="setViewMode('list')"><el-icon><List /></el-icon></button>
        </div>
        <button class="btn-primary" @click="openAdd"><el-icon><Plus /></el-icon><span>新增课程</span></button>
      </div>
    </div>

    <div v-if="viewMode === 'grid'" class="course-grid">
      <div class="course-card" v-for="item in filteredCourses" :key="item.id">
        <div class="course-card-header" :style="{ background: item.gradient }">
          <span class="course-cat-tag">{{ item.category }}</span>
          <div class="course-level-tag">{{ item.level }}</div>
        </div>
        <div class="course-card-body">
          <h3 class="course-title">{{ item.name }}</h3>
          <p class="course-coach"><el-icon><User /></el-icon>{{ item.coach }}</p>
          <div class="course-meta">
            <span><el-icon><Timer /></el-icon>{{ item.duration }}分钟</span>
            <span><el-icon><UserFilled /></el-icon>{{ item.enrolled }}/{{ item.capacity }}人</span>
            <span><el-icon><Calendar /></el-icon>{{ item.schedule }}</span>
          </div>
          <div class="course-prog-bar">
            <div class="course-prog-fill" :style="{ width: (item.enrolled/item.capacity*100)+'%', background: item.color }"></div>
          </div>
          <div class="course-footer">
            <div class="course-footer-left">
              <span class="course-price">¥{{ item.price }}<small>/节</small></span>
              <span class="course-status-tag" :class="'st-' + item.statusCode">{{ item.statusLabel }}</span>
            </div>
            <div class="course-actions">
              <button class="act-btn edit" @click="editItem(item)"><el-icon><Edit /></el-icon></button>
              <button class="act-btn del" @click="deleteItem(item)"><el-icon><Delete /></el-icon></button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="table-card">
      <el-table :data="filteredCourses" style="width:100%" :header-cell-style="headerStyle">
        <el-table-column type="index" label="#" width="55" />
        <el-table-column prop="name" label="课程名称" min-width="140" />
        <el-table-column prop="coach" label="教练" width="100" />
        <el-table-column prop="category" label="类型" width="100" />
        <el-table-column prop="level" label="难度" width="80" />
        <el-table-column prop="duration" label="时长(分)" width="95" />
        <el-table-column prop="capacity" label="容量" width="70" />
        <el-table-column label="价格" width="90">
          <template #default="{ row }">¥{{ row.price }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template #default="{ row }"><span class="course-status-tag" :class="'st-' + row.statusCode">{{ row.statusLabel }}</span></template>
        </el-table-column>
        <el-table-column prop="schedule" label="上课时间" min-width="120" show-overflow-tooltip />
        <el-table-column label="操作" width="100" fixed="right">
          <template #default="{ row }">
            <div class="table-actions">
              <button type="button" class="act-btn edit" @click="editItem(row)"><el-icon><Edit /></el-icon></button>
              <button type="button" class="act-btn del" @click="deleteItem(row)"><el-icon><Delete /></el-icon></button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog v-model="showDialog" :title="editing ? '编辑课程' : '新增课程'" width="560px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="课程名称"><el-input v-model="form.name" placeholder="请输入课程名称" /></el-form-item>
        <el-form-item label="授课教练">
          <el-select v-model="form.coachId" style="width:100%" placeholder="请选择教练">
            <el-option v-for="c in coaches" :key="c.coachId" :label="c.name" :value="c.coachId" />
          </el-select>
        </el-form-item>
        <el-form-item label="课程类型">
          <el-select v-model="form.category" style="width:100%">
            <el-option label="有氧训练" value="有氧训练" />
            <el-option label="力量训练" value="力量训练" />
            <el-option label="瑜伽" value="瑜伽" />
            <el-option label="搏击" value="搏击" />
            <el-option label="舞蹈" value="舞蹈" />
          </el-select>
        </el-form-item>
        <el-form-item label="难度">
          <el-select v-model="form.difficulty" style="width:100%">
            <el-option label="初级" value="初级" />
            <el-option label="中级" value="中级" />
            <el-option label="高级" value="高级" />
          </el-select>
        </el-form-item>
        <el-form-item label="课程时长"><el-input-number v-model="form.duration" :min="30" :max="180" :step="15" /></el-form-item>
        <el-form-item label="课程容量"><el-input-number v-model="form.capacity" :min="1" :max="100" /></el-form-item>
        <el-form-item label="课程价格"><el-input-number v-model="form.price" :min="0" :precision="0" /></el-form-item>
        <el-form-item label="上课时间"><el-input v-model="form.courseSchedule" placeholder="如：周一、三、五 09:00" /></el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width:100%">
            <el-option label="进行中" :value="1" />
            <el-option label="已下架" :value="0" />
            <el-option label="已结束" :value="2" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <button class="btn-secondary" @click="showDialog = false">取消</button>
          <button class="btn-primary" @click="saveItem">保存</button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { Search, Plus, Edit, Delete, User, UserFilled, Timer, Calendar, Notebook, TrendCharts, Star, Grid, List } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import api from '@/api/request';
import adminListViewModeMixin from '@/mixins/adminListViewMode';

const gradients = [
  'linear-gradient(135deg,#0062FF,#3D8BFF)',
  'linear-gradient(135deg,#10B981,#34D399)',
  'linear-gradient(135deg,#EF4444,#F87171)',
  'linear-gradient(135deg,#F59E0B,#FCD34D)',
  'linear-gradient(135deg,#8B5CF6,#A78BFA)',
  'linear-gradient(135deg,#06B6D4,#22D3EE)',
];
const colors = ['#0062FF', '#10B981', '#EF4444', '#F59E0B', '#8B5CF6', '#06B6D4'];

export default {
  name: 'CourseView',
  mixins: [adminListViewModeMixin],
  components: { Search, Plus, Edit, Delete, User, UserFilled, Timer, Calendar, Notebook, TrendCharts, Star, Grid, List },
  data() {
    return {
      courseFilterTab: 'all',
      courseFilterTabs: [
        { v: 'all', l: '全部' },
        { v: '1', l: '进行中' },
        { v: '0', l: '已下架' },
        { v: '2', l: '已结束' },
      ],
      searchQuery: '',
      showDialog: false,
      editing: null,
      form: { name: '', coachId: null, category: '有氧训练', difficulty: '初级', duration: 60, capacity: 20, price: 0, courseSchedule: '', status: 1 },
      coaches: [],
      courseStats: [
        { label: '课程总数', value: '-', icon: 'Notebook', bg: 'rgba(0,98,255,0.1)', color: '#0062FF' },
        { label: '进行中', value: '-', icon: 'Calendar', bg: 'rgba(16,185,129,0.1)', color: '#10B981' },
        { label: '已下架', value: '-', icon: 'TrendCharts', bg: 'rgba(245,158,11,0.1)', color: '#F59E0B' },
        { label: '已结束', value: '-', icon: 'Star', bg: 'rgba(139,92,246,0.1)', color: '#8B5CF6' },
      ],
      courses: []
    };
  },
  computed: {
    filteredCourses() {
      let list = this.courses;
      if (this.courseFilterTab !== 'all') {
        const s = Number(this.courseFilterTab);
        list = list.filter(c => c.statusCode === s);
      }
      const q = (this.searchQuery || '').trim();
      if (!q) return list;
      return list.filter(c =>
        (c.name && c.name.includes(q)) ||
        (c.coach || '').includes(q) ||
        (c.coachName || '').includes(q)
      );
    },
    headerStyle() {
      return { background: 'var(--bg-elevated)', color: 'var(--text-secondary)', fontWeight: 500 };
    },
  },
  mounted() {
    this.loadCourses();
    this.loadCoaches();
  },
  methods: {
    async loadCoaches() {
      try {
        const res = await api.getCoachList();
        if (res.data && res.data.code === 200) {
          this.coaches = res.data.data || [];
        }
      } catch (e) {}
    },
    async loadCourses() {
      try {
        const res = await api.getCourseList();
        if (res.data && res.data.code === 200) {
          const list = res.data.data || [];
          const stLabel = { 1: '进行中', 0: '已下架', 2: '已结束' };
          this.courses = list.map((c, i) => ({
            ...c,
            id: c.courseId,
            coach: c.coachName || '-',
            level: c.difficulty || '初级',
            enrolled: 0,
            schedule: c.courseSchedule || '-',
            statusCode: c.status,
            statusLabel: stLabel[c.status] != null ? stLabel[c.status] : '未知',
            gradient: gradients[i % gradients.length],
            color: colors[i % colors.length],
          }));
          this.courseStats[0].value = String(list.length);
          this.courseStats[1].value = String(list.filter(c => c.status === 1).length);
          this.courseStats[2].value = String(list.filter(c => c.status === 0).length);
          this.courseStats[3].value = String(list.filter(c => c.status === 2).length);
        }
      } catch (e) {}
    },
    openAdd() {
      this.editing = null;
      this.form = { name: '', coachId: null, category: '有氧训练', difficulty: '初级', duration: 60, capacity: 20, price: 0, courseSchedule: '', status: 1 };
      this.showDialog = true;
    },
    editItem(c) {
      this.editing = c;
      this.form = {
        courseId: c.courseId,
        name: c.name,
        coachId: c.coachId,
        category: c.category,
        difficulty: c.difficulty,
        duration: c.duration,
        capacity: c.capacity,
        price: c.price,
        courseSchedule: c.courseSchedule,
        status: c.status,
      };
      this.showDialog = true;
    },
    async deleteItem(c) {
      try {
        await ElMessageBox.confirm('确定删除课程 ' + c.name + '？', '提示', { type: 'warning' });
        const res = await api.removeCourse(c.courseId);
        if (res.data && res.data.code === 200) {
          ElMessage.success('删除成功');
          this.loadCourses();
        } else {
          ElMessage.error(res.data?.message || '删除失败');
        }
      } catch (e) {
        if (e !== 'cancel') ElMessage.error('操作失败');
      }
    },
    async saveItem() {
      try {
        const form = { ...this.form };
        let res;
        if (this.editing) {
          res = await api.updateCourse(form);
        } else {
          res = await api.saveCourse(form);
        }
        if (res.data && res.data.code === 200) {
          ElMessage.success('保存成功');
          this.showDialog = false;
          this.loadCourses();
        } else {
          ElMessage.error(res.data?.message || '保存失败');
        }
      } catch (e) {
        ElMessage.error('保存失败');
      }
    }
  }
};
</script>

<style scoped>
.page-wrapper { padding: 0; background: var(--bg-base); min-height: 100vh; }
.page-title { font-size: 22px; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; }
.breadcrumb { font-size: 13px; color: var(--text-muted); display: flex; gap: 6px; }
.breadcrumb .sep { color: var(--border-color); }
.breadcrumb .cur { color: var(--primary-blue); font-weight: 500; }
.filter-tabs { display: flex; gap: 6px; flex-wrap: wrap; }
.filter-tab { padding: 6px 16px; border: 1px solid var(--border-color); background: var(--bg-gray); color: var(--text-secondary); border-radius: var(--radius-sm); font-size: 13px; font-weight: 500; cursor: pointer; transition: all 0.3s; }
.filter-tab:hover { border-color: var(--primary-blue); color: var(--primary-blue); }
.filter-tab.active { background: var(--primary-blue); border-color: var(--primary-blue); color: white; }
.view-toggle { display: flex; gap: 4px; }
.view-btn { width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; border: 1px solid var(--border-color); background: var(--bg-white); color: var(--text-muted); border-radius: var(--radius-sm); cursor: pointer; transition: all 0.3s; }
.view-btn.active { background: rgba(0, 98, 255, 0.1); color: var(--primary-blue); border-color: var(--primary-blue); }
.search-box { display: flex; align-items: center; background: var(--bg-white); border: 1px solid var(--border-color); border-radius: var(--radius-md); padding: 0 12px; height: 38px; min-width: 200px; max-width: 280px; flex: 1; gap: 8px; transition: all 0.3s; }
.search-box:focus-within { border-color: var(--primary-blue); box-shadow: 0 0 0 3px rgba(0,98,255,0.08); }
.search-box .el-icon { color: var(--text-muted); }
.search-box input { border: none; background: transparent; color: var(--text-primary); font-size: 14px; outline: none; flex: 1; }
.search-box input::placeholder { color: var(--text-muted); }
.btn-primary { display: inline-flex; align-items: center; gap: 6px; padding: 0 18px; height: 38px; background: var(--gradient-primary); color: white; border: none; border-radius: var(--radius-md); font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.3s; }
.btn-primary:hover { transform: translateY(-1px); box-shadow: var(--shadow-glow); }
.btn-secondary { display: inline-flex; align-items: center; gap: 6px; padding: 0 18px; height: 38px; background: var(--bg-gray); color: var(--text-primary); border: 1px solid var(--border-color); border-radius: var(--radius-md); font-size: 14px; cursor: pointer; transition: all 0.3s; }
.btn-secondary:hover { border-color: var(--primary-blue); color: var(--primary-blue); }
.mini-stat { background: var(--bg-white); border: 1px solid var(--border-color); border-radius: var(--radius-lg); padding: 16px 20px; display: flex; align-items: center; gap: 14px; transition: all 0.3s; }
.mini-stat:hover { transform: translateY(-2px); box-shadow: var(--shadow-lg); }
.mini-stat-icon { width: 44px; height: 44px; border-radius: var(--radius-md); display: flex; align-items: center; justify-content: center; font-size: 20px; flex-shrink: 0; }
.mini-stat-val { font-size: 22px; font-weight: 700; color: var(--text-primary); margin: 0 0 2px; font-family: 'Inter', sans-serif; }
.mini-stat-label { font-size: 12px; color: var(--text-muted); margin: 0; }
.course-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 20px; }
.course-card { background: var(--bg-white); border: 1px solid var(--border-color); border-radius: var(--radius-xl); overflow: hidden; transition: all 0.3s; }
.course-card:hover { transform: translateY(-4px); box-shadow: var(--shadow-xl); }
.course-card-header { height: 100px; display: flex; align-items: flex-start; justify-content: space-between; padding: 16px; }
.course-cat-tag { background: rgba(255,255,255,0.25); color: white; padding: 4px 12px; border-radius: 20px; font-size: 12px; font-weight: 600; backdrop-filter: blur(4px); }
.course-level-tag { background: rgba(0,0,0,0.2); color: white; padding: 4px 10px; border-radius: 6px; font-size: 11px; font-weight: 600; }
.course-card-body { padding: 16px; }
.course-title { font-size: 16px; font-weight: 700; color: var(--text-primary); margin: 0 0 8px; }
.course-coach { font-size: 13px; color: var(--text-secondary); display: flex; align-items: center; gap: 5px; margin: 0 0 12px; }
.course-meta { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 12px; }
.course-meta span { font-size: 12px; color: var(--text-muted); display: flex; align-items: center; gap: 4px; }
.course-prog-bar { height: 4px; background: var(--border-light); border-radius: 2px; overflow: hidden; margin-bottom: 14px; }
.course-prog-fill { height: 100%; border-radius: 2px; transition: width 0.6s ease; }
.course-footer { display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; }
.course-footer-left { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.course-status-tag { font-size: 11px; font-weight: 600; padding: 3px 10px; border-radius: 20px; white-space: nowrap; }
.course-status-tag.st-1 { background: rgba(16,185,129,0.12); color: #10B981; }
.course-status-tag.st-0 { background: rgba(245,158,11,0.12); color: #F59E0B; }
.course-status-tag.st-2 { background: rgba(139,92,246,0.12); color: #8B5CF6; }
.course-price { font-size: 18px; font-weight: 700; color: var(--primary-blue); font-family: 'Inter', sans-serif; }
.course-price small { font-size: 12px; font-weight: 400; color: var(--text-muted); }
.course-actions { display: flex; gap: 6px; }
.act-btn { width: 30px; height: 30px; border: none; border-radius: var(--radius-sm); display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.3s; font-size: 14px; }
.act-btn.edit { background: rgba(245,158,11,0.1); color: #F59E0B; }
.act-btn.edit:hover { background: #F59E0B; color: white; }
.act-btn.del { background: rgba(239,68,68,0.1); color: #EF4444; }
.act-btn.del:hover { background: #EF4444; color: white; }
.table-card { background: var(--bg-white); border: 1px solid var(--border-color); border-radius: var(--radius-lg); overflow: hidden; }
.table-actions { display: flex; gap: 6px; }
.dialog-footer { display: flex; justify-content: flex-end; gap: 10px; }

@media (max-width: 480px) {
  .course-grid { grid-template-columns: 1fr; gap: 14px; }
}
</style>